import * as types from './reportConfigurationActionType';


export const fetchReportConfigurationRequest = (startDate = '', endDate = '') => ({
    type: types.FETCH_REPORT_CONFIGURATION_REQUEST,
    payload: { startDate, endDate }
});
export const fetchReportConfigurationSuccess = (data) => ({
    type: types.FETCH_REPORT_CONFIGURATION_SUCCESS,
    payload: data
});
export const fetchReportConfigurationFailure = (error) => ({
    type: types.FETCH_REPORT_CONFIGURATION_FAILURE,
    payload: error
});

export const saveReportConfigurationRequest = (ReportConfigurationData) => ({
    type: types.SAVE_REPORT_CONFIGURATION_REQUEST,
    payload: ReportConfigurationData
});
export const saveReportConfigurationSuccess = (ReportConfiguration) => ({
    type: types.SAVE_REPORT_CONFIGURATION_SUCCESS,
    payload: ReportConfiguration
});
export const saveReportConfigurationFailure = (error) => ({
    type: types.SAVE_REPORT_CONFIGURATION_FAILURE,
    payload: error
});

export const fetchReportConfigurationByIdRequest = (ReportConfigurationID) => ({
    type: types.FETCH_REPORT_CONFIGURATION_BY_ID_REQUEST,
    payload: { ReportConfigurationID }
});
export const fetchReportConfigurationByIdSuccess = (ReportConfiguration) => ({
    type: types.FETCH_REPORT_CONFIGURATION_BY_ID_SUCCESS,
    payload: ReportConfiguration
});
export const fetchReportConfigurationByIdFailure = (error) => ({
    type: types.FETCH_REPORT_CONFIGURATION_BY_ID_FAILURE,
    payload: error
});

export const activateDeactivateReportConfigurationRequest = (ReportConfigurationID, status, userId) => ({
    type: types.ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_REQUEST,
    payload: { ReportConfigurationID, status, userId }
});
export const activateDeactivateReportConfigurationSuccess = (result) => ({
    type: types.ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_SUCCESS,
    payload: result
});
export const activateDeactivateReportConfigurationFailure = (error) => ({
    type: types.ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_FAILURE,
    payload: error
});

export const fetchPowerBIRefreshStatusRequest = () => ({
    type: types.FETCH_POWERBI_REFRESH_STATUS_REQUEST
});
export const fetchPowerBIRefreshStatusSuccess = (data) => ({
    type: types.FETCH_POWERBI_REFRESH_STATUS_SUCCESS,
    payload: data
});
export const fetchPowerBIRefreshStatusFailure = (error) => ({
    type: types.FETCH_POWERBI_REFRESH_STATUS_FAILURE,
    payload: error
});

export const fetchCapacityDropdownRequest = (fromDate, toDate, configId = 0) => ({
    type: types.FETCH_CAPACITY_DROPDOWN_REQUEST,
    payload: { fromDate, toDate, configId }
});
export const fetchCapacityDropdownSuccess = (data) => ({
    type: types.FETCH_CAPACITY_DROPDOWN_SUCCESS,
    payload: data
});
export const fetchCapacityDropdownFailure = (error) => ({
    type: types.FETCH_CAPACITY_DROPDOWN_FAILURE,
    payload: error
});

// Update Dropdown management Reducer
export const reportReducer = data => ({
    type: types.UPDATE_REPORT_REDUCER,
    payload: data
});
